import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { isPresent } from '../util/lang';

export const passwordUseWord = (words: string[]): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } => {
    if (isPresent(Validators.required(control))) return null;

    return words.filter(word => control.value.includes(word))?.length > 0 ? { 'passwordUseWord': true } : null;
  };
};